import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, Inject, SimpleChanges } from '@angular/core';
import { TgrServiceService } from '../../../../service/tgr-service.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Quote, ResultTgrDetail } from '../../../../interface/tgr';
import { MatTableDataSource } from '@angular/material/table';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-tgr-form-detalle',
  templateUrl: './tgr-form-detalle.component.html',
  styleUrls: ['./tgr-form-detalle.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed,void', style({height: '0px', minHeight: '0'})),
      state('expanded', style({height: '*'})),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class TgrFormDetalleComponent {
  //public listDebtAgreement: TgrDebtWithAgreement[] = [];
  public agreements: ResultTgrDetail[] = [];
  public dataSource: MatTableDataSource<ResultTgrDetail>;
  public columnsToDisplay = ['folio', 'resolutionDate', 'activationDate', 'agreementType', 'totalAmountQuotes'];
  public columnsToDisplayWithExpand = [...this.columnsToDisplay, 'quotesButton', 'debtsButton'];
  public expandedElement: ResultTgrDetail | null;
  public innerExpandedElement: Quote | null;
  public quoteColumns = ['dueDate', 'amount', 'quota', 'paid'];
  public debtColumns = ['debtType', 'form', 'folio', 'endDate', 'condOtorgadaIntereses', 'condOtorgadaMulta', 'totalAmountToPay'];
  public ocultarDebt: boolean = false;
  public ocultarQuotas: boolean = false;
  public cargandoTgrDetail: boolean = true;

  constructor(@Inject(MAT_DIALOG_DATA) public data: number, private serviceTgr: TgrServiceService) {
    this.dataSource = new MatTableDataSource();
  }

  ngOnInit() {
    this.cargarDataSourece();
    this.obtenerDetalleTgr(this.data);
  }

  ngOnChanges(changes: SimpleChanges) {
    console.log("Cambio detectado");
    this.cargarDataSourece();
    if (changes['data']) {
      const newDeptorsFilter = changes['data'].currentValue;
      this.cargarDataSourece();
    }
  }

  public obtenerDetalleTgr(companyId: number) {
    this.serviceTgr.getTgrDetail(companyId).subscribe({
      next: (result) => {
        console.log("Deatlle Tgr: ", result);
        this.agreements = result;
        this.cargarDataSourece();
        this.cargandoTgrDetail = false;
      }
    })
  }

  public cargarDataSourece() {
    this.dataSource.data = this.agreements;
  }

  public ocultarTabQuotas() {
    this.ocultarQuotas = true;
    this.ocultarDebt = false;
  }

  public ocultarTabDebts() {
    this.ocultarDebt = true;
    this.ocultarQuotas = false;
  }


  exportToExcel(): void {
    // Obtén los datos del dataSource
    const data = this.dataSource?.data || [];

      // Función para formatear un número como moneda
    const formatCurrency = (value: number): string => {
      return new Intl.NumberFormat('es-CL', { style: 'currency', currency: 'CLP' }).format(value);
    };

  // Función para formatear una fecha
  const formatDate = (dateString: any): string => {
    const date = new Date(dateString);
    if (date instanceof Date && !isNaN(date.getTime())) {
      return new Intl.DateTimeFormat('es-CL').format(date);
    }
    // Si no es una fecha válida, devuelve un mensaje por defecto o un campo vacío
    return 'Fecha Inválida';
  };
  
    // Aplana los datos Tgr
    const tgrData = data.map(item => ({
      Folio: item.folio,
      FechaResolucion: formatDate(item.resolutionDate),
      FechaActivacion: formatDate(item.activationDate),
      TipoConvenio: item.agreementType,
      Total: formatCurrency(item.totalAmountQuotes)
      // Puedes agregar otros campos aquí
    }));
  
    // Aplana los datos de Cuotas
    const quotesData = data.flatMap(item =>
      item.quotes.map(quote => ({
        Folio: item.folio,
        FechaVencimiento: formatDate(quote.dueDate),
        Cuota: quote.quota,
        Monto: formatCurrency(quote.amount),
        Pagado: quote.paid ? 'PAGADO' : 'SIN PAGAR'
        // Puedes agregar otros campos de quote aquí
      }))
    );

        // Aplana los datos de Deudas
    const debtdata = data.flatMap(item =>
      item.tgrDebtWithAgreement.map(debt => ({
        Folio: item.folio,
        Formulario: debt.form,
        FechaVencimiento: formatDate(debt.endDate),
        ConIntereses : debt.condOtorgadaIntereses+"%",
        ContMulta: debt.condOtorgadaMulta+"%",
        Total: formatCurrency(debt.totalAmountToPay)
        // Puedes agregar otros campos de quote aquí
      }))
    );
  
    // Crea un libro de trabajo (workbook)
    const wb = XLSX.utils.book_new();
  
    // Convierte los datos principales a una hoja de cálculo (worksheet)
    const mainSheet = XLSX.utils.json_to_sheet(tgrData);
    XLSX.utils.book_append_sheet(wb, mainSheet, 'Convenios');
  
    // Convierte los datos de quotes a una hoja de cálculo (worksheet)
    const quotesSheet = XLSX.utils.json_to_sheet(quotesData);
    XLSX.utils.book_append_sheet(wb, quotesSheet, 'Cuotas Pactadas');
  
    // Convierte los datos de quotes a una hoja de cálculo (worksheet)
    const debtSheet = XLSX.utils.json_to_sheet(debtdata);
    XLSX.utils.book_append_sheet(wb, debtSheet, 'Deudas en Convenios');

    // Genera el archivo Excel
    const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
  
    // Crear un objeto URL para el archivo
    const blob = new Blob([wbout], { type: 'application/octet-stream' });
    const url = URL.createObjectURL(blob);
  
    // Crear un enlace para la descarga
    const a = document.createElement('a');
    a.href = url;
    a.download = 'TGR.xlsx';
  
    // Simular el clic en el enlace para iniciar la descarga
    document.body.appendChild(a);
    a.click();
  
    // Limpiar
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }
  
  

}
